import { defineMessages } from 'react-intl';

const translations = {
  fields: {
    content: {
      label: {
        id: 'properties.message',
        defaultMessage: 'Message',
        description: 'label of the form field content',
      },
    },
  },
  formActions: {
    createComment: {
      id: 'conversationList.actions.addComment',
      defaultMessage: 'Add comment',
      description: 'Title of the action add comment',
    },
  },
};

export default defineMessages(translations);
